import moment from 'moment';
import React, { useMemo } from 'react';
import { DATE_FORMAT, DATE_TIME_FORMAT } from '@atlassian/cssxp-typescommon';

interface ComponentProps {
  /** Date formatted as ISO string ("1970-01-19T13:44:50.306Z") */
  date?: string | null;
  showTime?: boolean;
  format?: string;
}

const isNumber = (value: string) => /^\d+$/.test(value);

export const convertToMilliSeconds = (date: string) => {
  switch (date.length) {
    case 10:
      return parseInt(date, 10) * 1000;
    case 13:
      return parseInt(date, 10);
    case 16:
      return parseInt(date, 10) / 1000;
    default:
      return 10000000000000000;
  }
};

export const getFormattedDateString = ({ date, showTime = false, format }: ComponentProps): string | null => {
  const dateFormat = format ? format : showTime ? DATE_TIME_FORMAT : DATE_FORMAT;

  if (!date) {
    return null;
  }

  if (isNumber(date)) {
    return moment.utc(convertToMilliSeconds(date)).format(dateFormat);
  } else {
    return moment.utc(date).format(dateFormat);
  }
};

const FormattedDate = ({ date, showTime = false, format }: ComponentProps) => {
  const dateFormat = useMemo(() => {
    if (format) return format;
    return showTime ? DATE_TIME_FORMAT : DATE_FORMAT;
  }, [format, showTime]);

  if (!date) {
    return <span />;
  }
  return (
    <span>
      {isNumber(date)
        ? moment.utc(convertToMilliSeconds(date)).format(dateFormat)
        : moment.utc(date).format(dateFormat)}
    </span>
  );
};

export default FormattedDate;
